import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Checks if the current user is a member of the given group.
 * Returns { isMember, loading } — use to guard group-scoped pages.
 */
export function useGroupMembership(groupId: string | undefined, userId: string | undefined) {
  const [isMember, setIsMember] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!groupId || !userId) {
      setLoading(false);
      setIsMember(false);
      return;
    }

    supabase
      .from('group_members')
      .select('user_id')
      .eq('group_id', groupId)
      .eq('user_id', userId)
      .maybeSingle()
      .then(({ data }) => {
        setIsMember(!!data);
        setLoading(false);
      });
  }, [groupId, userId]);

  return { isMember, loading };
}
